/* Right-side "Shop The Look" drawer for the Lookbook page.
   - Every look's product grid is already rendered server-side inside its
     own hidden ".shop-the-look-drawer__panel" (no AJAX needed, unlike
     search-drawer.js, since the products are known ahead of time from the
     block settings) -- opening the drawer just un-hides the matching panel
     and hides the rest.
   - Reuses global.js's trapFocus/removeTrapFocus helpers (loaded
     non-deferred in <head>, ready before this deferred script runs) and
     the same open/close class pattern as CartDrawer/QuickViewDrawer/
     SearchDrawer for consistency -- including the required
     ".drawer:not(.active){pointer-events:none}" closed-state rule already
     shipped in component-cart-drawer-overrides.css (targets the shared
     ".drawer" class, so it covers this drawer for free). */
(function () {
  class ShopTheLookDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('.shop-the-look-drawer__overlay');
      this.closeButton = this.querySelector('.shop-the-look-drawer__close');
      this.panels = Array.from(this.querySelectorAll('[data-look-panel]'));
      this.openedBy = null;

      this.overlay && this.overlay.addEventListener('click', this.close.bind(this));
      this.closeButton && this.closeButton.addEventListener('click', this.close.bind(this));
      this.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') this.close();
      });
    }

    showPanel(lookId) {
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== lookId;
      });
    }

    open(triggeredBy, lookId) {
      this.showPanel(lookId);
      this.openedBy = triggeredBy || null;
      setTimeout(() => this.classList.add('active'));
      document.body.classList.add('overflow-hidden');
      const inner = this.querySelector('.drawer__inner');
      if (inner && typeof trapFocus === 'function') trapFocus(inner, this.closeButton || inner);
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.openedBy);
      document.body.classList.remove('overflow-hidden');
    }
  }

  if (!customElements.get('shop-the-look-drawer')) {
    customElements.define('shop-the-look-drawer', ShopTheLookDrawer);
  }

  function initTriggers() {
    document.querySelectorAll('[data-shop-the-look]').forEach((trigger) => {
      if (trigger.dataset.shopLookBound) return;
      trigger.dataset.shopLookBound = 'true';
      trigger.addEventListener('click', () => {
        const drawer = document.querySelector('shop-the-look-drawer');
        const lookId = trigger.getAttribute('data-look-panel');
        if (!drawer || !lookId) return;
        drawer.open(trigger, lookId);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTriggers);
  } else {
    initTriggers();
  }
  document.addEventListener('shopify:section:load', initTriggers);
})();
